import { CommonModule, formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { BrowserStorageService } from '../../shared/services/common/browser-storage.service';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { api } from '../../utils/endpoints';
import { fileDirectories } from '../../utils/view-settings';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DATE_FORMAT, LIMIT, MAX_SIZE } from '../../utils/constants';
import { ViewStorePopupComponent } from '../../shared/popups/view-store-popup/view-store-popup.component';
@Component({
  selector: 'app-common-news',
  imports: [CarouselModule, CommonModule, NgbModule, InfiniteScrollModule],
  templateUrl: './common-news.component.html',
  styleUrl: './common-news.component.scss',
})
export class CommonNewsComponent {
  DATE_FORMAT = DATE_FORMAT;
  newsList: any;
  fileDirectoriesPath: any = fileDirectories.profile;
  @Input() usedFor: any;
  selectedDateFilters: any = { from: null, to: null };
  selectedFilters: any;
  appliedFilters: any = [];
  @Output() pageChange = new EventEmitter<number>();
  pagination = { limit: LIMIT, maxSize: MAX_SIZE, skip: 0, totalItems: 0, row: 0, text: 'Loading...' };

  @Output() xdge = new EventEmitter<number>();
  constructor(
    private _storageService: BrowserStorageService,
    private ref: ChangeDetectorRef,
    private _activatedRoute: ActivatedRoute,
    private _apiService: ApiCallsService,
    private _router: Router,
        private _ngbModal: NgbModal
  ) {}
  ngOnChanges(objectPropertys: any) {
    this._activatedRoute.queryParams.subscribe((params: any) => {
      if (params.filter && params.selectedFilters) {
        this.selectedFilters = JSON.parse(params.selectedFilters);
        this.appliedFilters = JSON.parse(params.selectedFilters);
      }
      if (params.selectedDateFilters) {
        this.selectedDateFilters = JSON.parse(params.selectedDateFilters);
      }
      this.newsList = [];
      this.getnewsList();
    });
  }
  getnewsList() {
    this._apiService.post(api._mediasListing, this._getRequest()).subscribe({
      next: (res: any) => {
        if (res) {
          this.pagination.totalItems = res.data.count;
          this.pageChange.emit(this.pagination.totalItems);
          this.pagination.row = res.data.rows.length;
          this.pagination.text = 'No record found!';
          if (this.usedFor != 'home') {
            res.data.rows.map((value: any) => {
              this.newsList.push(value);
            });
            this.xdge.emit(res.data.count);
          } else {
            this.newsList = res.data.rows;
            this.xdge.emit(res.data.count);
          }

          this.ref.detectChanges();
        }
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }
  private _getRequest(): HttpParams {
    let currentPage = Number.isNaN(this.pagination.skip) || this.pagination.skip == 0 ? 1 : this.pagination.skip;
    this.pagination.skip = currentPage;
    let params: any = {};
    if (this.selectedFilters != null) {
      if (this.selectedFilters && this.selectedFilters.length > 0) {
        let value: any[] = this.selectedFilters;
        let sportID: any[] = [];
        value.map((data: any) => {
          sportID.push(data.toString());
        });
        if (sportID.length > 0) {
          params['sportId'] = sportID;
        }
      }
    }
    if (this.selectedDateFilters && this.selectedDateFilters.from != null && this.selectedDateFilters.to != null) {
      params['createdAtFrom'] = formatDate(new Date(this.selectedDateFilters.from), 'yyyy-MM-dd', 'en-US');
      params['createdAtTo'] = formatDate(new Date(this.selectedDateFilters.to), 'yyyy-MM-dd', 'en-US');
    }

    if (this.usedFor == 'home') {
      params['limit'] = 3;
    } else {
      params['limit'] = this.pagination.limit;
    }

    params['page'] = currentPage;
    return params;
  }
  viewNewsDetails(data: any) {
    let adminDetail = this._storageService.getItem('userDetail');
    if (adminDetail) {
      this._router.navigate(['media/' + data.id]);
    } else {
          let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
            scrollable: false,
            backdrop: 'static',
            keyboard: false,
            size: 'filterPopup',
            centered: true,
          });
        }
  }
}
